module.exports = __webpack_public_path__ + "static/media/logoinpi.3ded0a87.svg";